import React, { useEffect, useState } from "react";
import DTOCreateBoardModal from "./DTOCreateBoardModal";
import CreateBoardModalPresenter from "./CreateBoardModalPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const CreateBoardModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOCreateBoardModal />

      <CreateBoardModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default CreateBoardModalController;
